// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3E8AQ","filesListContainer":"PosDisputesFiles_filesListContainer__3Tm8i","filesButton":"PosDisputesFiles_filesButton__2JfUi"};